import { combineReducers, configureStore } from "@reduxjs/toolkit";
import commonReducer from "../features/common/commonSlice";
import loadingReducer from "../features/common/loadingSlice";
import toasterReducer from "../features/common/toasterSlice";
import { featureReducers } from "../../reducers/injectReducters";
export const registerReducers = () => combineReducers(Object.assign({ common: commonReducer, loading: loadingReducer, toaster: toasterReducer }, featureReducers));
export const store = configureStore({
    reducer: registerReducers(),
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
});
